export async function setSessionLogger() {
  const { VITE_APP_LOG_ROCKET_ID } = import.meta.env;

  if (VITE_APP_LOG_ROCKET_ID && VITE_APP_LOG_ROCKET_ID !== 'null') {
    const { default: LogRocket } = await import('logrocket');
    LogRocket.init(VITE_APP_LOG_ROCKET_ID);
  }
}

export async function setSessionLoggedUser(user) {
  const {
    VITE_APP_LOG_ROCKET_ID,
    VITE_APP_CUSTOMER,
    VITE_APP_LOG_ROCKET_IDENTIFY,
  } = import.meta.env;

  if (VITE_APP_LOG_ROCKET_ID && VITE_APP_LOG_ROCKET_IDENTIFY) {
    const { default: LogRocket } = await import('logrocket');
    LogRocket.identify(user.email, {
      // Add your own custom user variables here, ie:
      ...user,
      customer_tenant_id: VITE_APP_CUSTOMER,
    });
  }
}
